import { render, staticRenderFns } from "./YA_CreateBot.vue?vue&type=template&id=2cacb26f&scoped=true"
import script from "./YA_CreateBot.vue?vue&type=script&lang=js"
export * from "./YA_CreateBot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cacb26f",
  null
  
)

export default component.exports